import {commitMutation, Disposable, Environment, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../MutationTypes';
import {UpdateGoogleCalendarInput, UpdateGoogleCalendarMutation} from './__generated__/UpdateGoogleCalendarMutation.graphql';

const mutation = graphql`
	mutation UpdateGoogleCalendarMutation($input: UpdateGoogleCalendarInput!) {
		updateGoogleCalendar(input: $input) {
			googleCalendar {
				calendarViewPrivateEvents
				enabledCalendars
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateGoogleCalendarInput>,
	onSuccess: RelayOnCompleted<UpdateGoogleCalendarMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	const optimisticResponse = {
		updateGoogleCalendar: {
			googleCalendar: {
				id: input.id,
				calendarViewPrivateEvents: input.viewPrivateEvents,
				enabledCalendars: input.enabledCalendarIds,
			},
		},
	};

	return commitMutation(environment, {
		mutation,
		variables,
		optimisticResponse,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
